/*
 * iiimagine-frontend - Jobs.tsx
 * Job data and type definitions
 *
 * Updated for nested whatYouWillBeDoing structure (intro, tasks, outro)
 */

import React from "react";

// Define flexible shape for whatYouWillBeDoing
export type WhatDoing =
  | string[]
  | {
      intro: string;
      tasks: string[];
      outro?: string;
    };

// Define the Job interface
export interface Job {
  title: string;
  description: React.ReactNode;
  period?: string;
  whatYouWillBeDoing: WhatDoing;
  requirements: string[];
  video?: {
    url: string;
    thumbnail?: string;
  };
  interested: React.ReactNode;
}

// Define the list of jobs
export const jobs: Job[] = [
  {
    title: "Production Crew",
    description: (
      <>
        <p>
          Behind the scenes, we are working on our most ambitious project yet:{" "}
          <a
            href="https://prodigy12.com/"
            target="_blank"
            className="text-iiimagine-red"
            rel="noreferrer"
          >
            Prodigy12
          </a>{" "}
          will be a 360° live spectacle in a futuristic, traveling pavilion that
          we are building.
        </p>

        <p>
          This is your opportunity to join a fast-growing creative startup that
          aims to redefine how people experience live shows.
        </p>

        <p>
          Directed by the Roelandt Brothers, we are builders as much as
          creators. Beyond creating the screenplay, visuals, and music, we
          physically construct the production ourselves — from the stage
          structure and rigging to light, sound, and LED. We also oversee
          ticketing and operations, bringing the full experience directly to the
          audience, without intermediaries.
        </p>

        <p>
          We are looking for someone who is not only a good person but also
          strives for excellence in what they do. Together, we believe that a
          strong team can accomplish a great deal. People who are motivated,
          driven to build, curious to learn, and eager to join the journey. We
          have a clear vision for Prodigy12 and will do our best to make you
          fly.
        </p>
      </>
    ),

    period: "Freelance",

    whatYouWillBeDoing: {
      intro: "You will be involved in all aspects of live production, including:",
      tasks: [
        "Scaffolding",
        "Rigging",
        "LED and video setup",
        "Truss and stage construction",
        "Lighting",
        "Sound",
        "Electricity",
      ],
      outro: "while being guided by our Head of Production.",
    },

    requirements: [
      "Strong curiosity and a desire to create something exceptional",
      "A strong work ethic, we expect the same commitment from you as from the team",
      "High attention to detail",
      "Bonus: Experience working with wood or metal",
    ],

    interested: (
      <>
        <p>
          Phase 1: Please email your CV, cover letter, and (if available)
          portfolio to{" "}
          <a
            href="mailto:production@prodigy12.com"
            className="text-iiimagine-red"
          >
            production@prodigy12.com
          </a>
          <br />
          Phase 2: 30-minute telephone interview
          <br />
          Phase 3: Test
        </p>
        <br />
        <p>Looking forward to reviewing your application!</p>
      </>
    ),
  },
];
